import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CmsService {
  apiUrl: string = environment.apiUrl;

  constructor(private httpClient: HttpClient) { }

  getAuthPageConfig() {
    return this.httpClient.get(`${this.apiUrl}auth/page-config`);
  }

  getManageConfig() {
    return this.httpClient.get(`${this.apiUrl}cms/manage`);
  }

  saveSliderItem(payload: any, file?: File | null) {
    const formData = new FormData();
    formData.append(
      'data',
      new Blob([JSON.stringify(payload)], { type: 'application/json' })
    );
    if (file) {
      formData.append('file', file);
    }
    return this.httpClient.post(`${this.apiUrl}cms/slider-items`, formData);
  }

  updateSliderItemStatus(id: number, status: string) {
    return this.httpClient.patch(`${this.apiUrl}cms/slider-items/${id}/status`, null, {
      params: { status }
    });
  }

  saveSettings(payload: any, authBackgroundFile?: File | null, companyLogoFile?: File | null) {
    const formData = new FormData();
    formData.append(
      'data',
      new Blob([JSON.stringify(payload)], { type: 'application/json' })
    );
    if (authBackgroundFile) {
      formData.append('authBackgroundFile', authBackgroundFile);
    }
    if (companyLogoFile) {
      formData.append('companyLogoFile', companyLogoFile);
    }
    return this.httpClient.post(`${this.apiUrl}cms/settings`, formData);
  }

  sendTestMail(payload: { toEmail: string }) {
    return this.httpClient.post(`${this.apiUrl}cms/mail/test`, payload);
  }
}
